import { forIPhone5, forTablet } from '@westwing/ui-kit/breakPoints';
import Modal from '@westwing/ui-kit/Modal';
import { body2, body2Bold } from '@westwing/ui-kit/typography';
import styled from 'styled-components';
import Text from '../Typography/Text';

export const OverwhelmedForm = styled(Modal.Content)`
    width: 100vw;
    min-height: 350px;
    padding: 20px;
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.charcoal100};
    text-align: center;
    position: relative;
    display: grid;
    place-items: center;
    align-content: center;

    ${forIPhone5`
        padding: 10px;
    `}

    ${forTablet`
        padding: 40px;
        width: min(430px, 100vw);
    `}
`;

export const Form = styled.form``;

export const FormTitle = styled(Text)`
    margin-bottom: 20px;
`;

export const FormDescription = styled.p`
    ${body2}
    margin-bottom: 10px;
`;

export const FormQuestion = styled.p`
    ${body2Bold}
    margin-bottom: 20px;
`;

export const ThankYouNote = styled.div``;

export const Label = styled.label`
    display: none;
`;

export const Fieldset = styled.fieldset`
    all: unset;
    width: 100%;
`;

export const EmailInput = styled.input`
    padding: 16px;
    width: 100%;
    height: 52px;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.charcoal20};
    margin-bottom: 10px;
`;
